export const HttpErrorCodeConst =
{
  InvalidCredentialsNeedCaptcha: "invalidCredentialsNeedCaptcha",
  InvalidCredentials: "invalidCredentials"
};
